"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = [{
  value: '',
  label: 'No'
}, {
  value: '16/9',
  label: '16/9',
  aspectRatio: 16 / 9
}, {
  value: '4/3',
  label: '4/3',
  aspectRatio: 4 / 3
}];